//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class PersonEntityService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[PersonEntity.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/person-entity/detail', {'params':params});
	};

	//GeneratorFlag:[PersonEntity.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/person-entity/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}